import {makeAutoObservable} from "mobx";

class ModalsStore {
    Modals = {
        EditPatient2: {
            visibility: false,
            methods: {
                submit() {},
                update() {},
                closeHandler() {},
            },
            data: {
                patientId: '',
                initialForm: {},
                disabledFields: {
                    fio: false,
                    dob: false,
                    phone: false,
                    medBook: false,
                    address: false,
                    jobName: false,
                    medCenter: false,
                    organization: false,
                }
            }
        },
        QuizMammoModal: {
            visibility: false,
            methods: {
                submit() {},
                update() {},
                closeHandler() {},
            },
            data: {
                patientId: '',
                initialForm: {},
                disabledFields: {
                    fio: false,
                    dob: false,
                    phone: false,
                    medBook: false,
                    address: false,
                    jobName: false,
                    medCenter: false,
                    organization: false,
                }
            }
        },
        QuizRentgenModal: {
            visibility: false,
            methods: {
                submit() {},
                update() {},
                closeHandler() {},
            },
            data: {
                patientId: '',
                initialForm: {},
                disabledFields: {
                    fio: false,
                    dob: false,
                    phone: false,
                    medBook: false,
                    address: false,
                    jobName: false,
                    medCenter: false,
                    organization: false,
                }
            }
        },
        QuizVeterinarModal: {
            visibility: false,
            methods: {
                submit() {},
                update() {},
                closeHandler() {},
            },
            data: {
                patientId: '',
                initialForm: {},
                disabledFields: {
                    fio: false,
                    dob: false,
                    phone: false,
                    medBook: false,
                    address: false,
                    jobName: false,
                    medCenter: false,
                    organization: false,
                }
            }
        },
        AssistantsModal: {
            visibility: false,
            methods: {
                submit() {},
                closeHandler() {},
            },
            data: {
                initialForm: {},
                editingMode: false,
                roleSelectOptions: [],

                disabledFields: {
                    verCenter: false,
                    fio: false,
                    login: false,
                    password: false,
                    medBook: false,
                    email: false,
                    role: false,
                    phone: false
                }

            }
        }
    }

    constructor() {
        makeAutoObservable(this)
    }

    showModal(name = '', data = {}, methods = {}) {
        this.Modals[name].data = {...data}
        this.Modals[name].methods = {...methods}
        this.Modals[name].visibility = true
    }

    closeModal(name = '') {
        this.Modals[name].visibility = false
        this.Modals[name].methods.closeHandler()
    }
}


export default new ModalsStore()